import React from 'react'

import InputContainer from './InputContainer.js'
import JiraWikiEditor from '../JiraWikiEditor'

export default ({ label, input, title, meta, ...props }) => (  
  <InputContainer label={label} meta={meta} title={title} type='wiki'>
      <JiraWikiEditor {...input} {...props}/>    
  </InputContainer>
)


// WEBPACK FOOTER //
// ./client/src/components/forms/WikiInput.js